exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animate-crossfade__container__1bxep{height:100%}.animate-crossfade__slide__3tef7{position:absolute;top:0;left:0;right:0;bottom:0;opacity:0}.animate-crossfade__active__1RNyD,.animate-crossfade__prevActive__18Q_F{opacity:1}.animate-crossfade__active__1RNyD{position:absolute;top:0;left:0;right:0;bottom:0;transition:opacity .3s ease-in-out;z-index:126}", ""]);

// exports
exports.locals = {
	"container": "animate-crossfade__container__1bxep",
	"slide": "animate-crossfade__slide__3tef7",
	"active": "animate-crossfade__active__1RNyD",
	"prevActive": "animate-crossfade__prevActive__18Q_F"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/animate-crossfade/animate-crossfade.styl
// module id = 2904
// module chunks = 1